import { useFormContext } from 'react-hook-form';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { NotesDisplay } from '../NotesDisplay';
import { Note } from '@/types';
import { useAuth } from '@/providers/AuthProvider';
import { FormTextarea } from '@/components/shared/FormTextArea';
import { useAddTicketNote } from '@/hooks/api/useTickets';
import { toast } from 'sonner';

interface TicketDetailsNotesTabProps {
  ticketId: string;
  canEdit: boolean;
}

export const TicketDetailsNotesTab = ({
  ticketId,
  canEdit,
}: TicketDetailsNotesTabProps) => {
  const { register, setValue, watch } = useFormContext();
  const formValues = watch();
  const notes: Note[] = formValues.notes || [];
  const { user } = useAuth();
  const { addTicketNote, isUpdating } = useAddTicketNote();

  const handleAddNote = () => {
    const newNoteContent = formValues.newNote?.trim();
    if (!newNoteContent || !user) return;
    const newNote: Note = {
      // id: crypto.randomUUID(),
      content: newNoteContent,
      createdById: user.id,
      createdAt: new Date().toISOString(),
      ticketId: ticketId,
      title: '',
      updatedAt: new Date().toISOString(),
    };
    // setValue('notes', [...(formValues.notes || []), newNote], {
    //   shouldDirty: true,
    // });
    // setValue('newNote', '');

    addTicketNote(
      { ...newNote },
      {
        onSuccess: () => {
          setValue('newNote', '');
          toast.success('Note added successfully');
        },
      },
    );
  };

  if (!canEdit) {
    return (
      <div className="pt-4">
        {notes.length > 0 ? (
          <ScrollArea className="h-[260px] pr-4">
            <NotesDisplay initialNotes={notes} />
          </ScrollArea>
        ) : (
          <div className="rounded-md bg-muted p-6 text-center">
            <p className="text-muted-foreground">No notes for this ticket.</p>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="space-y-4 pt-4">
      {notes.length > 0 && (
        <ScrollArea className="h-[180px] pr-4">
          <NotesDisplay initialNotes={notes} />
        </ScrollArea>
      )}
      <div className="space-y-2">
        <FormTextarea name="newNote" placeholder="Add a new note.." />
        <Button
          type="button"
          size="sm"
          className="w-full"
          onClick={handleAddNote}
          disabled={isUpdating}
        >
          Add Note
        </Button>
      </div>
    </div>
  );
};
